"use client";

import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ProductCard from "../Cards/ProductCard";
import wwd1 from "../../../public/assets/beer-bottle-amber.jpg";
import wwd2 from "../../../public/assets/beer-bottle-green.jpg";
import wwd3 from "../../../public/assets/food-jar.jpg";
import wwd4 from "../../../public/assets/liquor-bottles.jpg";
import wwd5 from "../../../public/assets/pharma-products.jpg";
import wwd6 from "../../../public/assets/sheet-glass.jpg";
const products = [
  {
    id: 1,
    href: "/beer-bottle",
    title: "Beer Bottle - Amber",
    image: wwd1,
  },
  {
    id: 2,
    href: "/beer-bottle/",
    title: "Beer Bottle - Green",
    image: wwd2,
  },
  {
    id: 3,
    href: "/food-jar",
    title: "Food Jar",
    image: wwd3,
  },
  {
    id: 4,
    href: "/liquor-bottle",
    title: "Liquor Bottles",
    image: wwd4,
  },
  {
    id: 5,
    href: "/pharma-bottle",
    title: "Pharma Products",
    image: wwd5,
  },
  {
    id: 6,
    href: "/sheet-glass",
    title: "Sheet Glass",
    image: wwd6,
  },
];

const MoreToExploreMobile = () => {
  const settings = {
    infinite: true,
    speed: 5000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
    arrows: false,
    dots: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 640,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className="w-full block overflow-x-hidden  xl:hidden">
      <Slider {...settings}>
        {products.map((product, index) => (
          <div key={index} className="px-3">
            <ProductCard
              image={product.image}
              title={product.title}
              href={product.href}
            />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default MoreToExploreMobile;
